import Api from "./base/api-base";

export default class UserMasterApi {
  list() {
    return Api.get({
      endpoint: Api.endpoint.user
    });
  }

  store (params) {
    return Api.post({
      endpoint: Api.endpoint.user,
      params: params
    });
  }

  info (id) {
    return Api.get({
      endpoint: Api.endpoint.user,
      id: id
    });
  }

  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.user,
      id: id,
      params: params
    });
  }

  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.user,
      id: id
    });
  }
}